import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson16: FunctionComponent = () => {
  return (
    <div className="relative bg-gray-100 w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.88rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between text-[1.56rem]">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson15"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Gratitude</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson17"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="self-stretch flex flex-col items-center justify-center gap-[6.25rem] text-justify text-white font-dm-sans">
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Why is Gratitude Important?</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The philosophy of gratitude and its relation to spirituality
                  and religions have deep historical roots. While gratitude is a
                  concept that transcends specific religious or spiritual
                  traditions, its principles have been incorporated into various
                  belief systems throughout history.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[29.75rem] h-[26rem] object-cover"
            alt=""
            src="/30@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0 text-[1.88rem] text-white">
            <b>History of Gratitude</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            In ancient times, gratitude was closely intertwined with spiritual
            and religious practices. For example, in ancient Greece, the concept
            of Eucharist, meaning "thanksgiving" or "gratitude," was integral to
            their religious rituals. The Greeks expressed gratitude to their
            deities through ceremonies and offerings, recognizing the blessings
            bestowed upon them.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            In Eastern philosophies and religions, such as Hinduism and
            Buddhism, gratitude is an essential aspect of spiritual growth and
            enlightenment. Gratitude is seen as a means of recognizing the
            interconnectedness of all beings and expressing appreciation for the
            abundance of life. Practitioners are encouraged to cultivate a
            grateful heart as they journey on their spiritual path.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Within Christianity, gratitude is deeply rooted in the teachings of
            Jesus Christ. The act of giving thanks is emphasized throughout the
            New Testament, with gratitude seen as an expression of faith and a
            way to honour God's blessings. Thanksgiving prayers and celebrations
            are significant aspects of Christian worship, encouraging believers
            to express gratitude for God's grace and provision.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            In Islam, gratitude is a central theme, with believers encouraged to
            express thankfulness to Allah for His blessings and guidance. The
            Qur'an emphasizes the importance of recognizing and appreciating the
            favours bestowed upon individuals, reminding them to be grateful for
            the blessings of life and to share their abundance with others.
          </p>
          <p className="m-0">
            Beyond specific religious traditions, gratitude has also been
            explored in philosophical and spiritual teachings.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Philosophers such as Marcus Aurelius, Epictetus, and Seneca in
            Stoicism, as well as ancient Chinese philosophers like Confucius,
            emphasized the cultivation of gratitude as a virtue essential for
            leading a fulfilling and ethical life.
          </p>
          <p className="m-0">
            In modern times, gratitude has gained renewed attention within the
            field of positive psychology. Scientific research has demonstrated
            the numerous psychological and physiological benefits of gratitude
            practices, confirming what spiritual traditions have long espoused.
            These studies have highlighted the positive impact of gratitude on
            mental well-being, relationships, resilience, and overall life
            satisfaction.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Regardless of religious or spiritual affiliation, gratitude serves
            as a unifying principle that encourages individuals to recognize and
            appreciate the blessings in their lives. It fosters humility,
            contentment, and a sense of interconnectedness with others and the
            world. Gratitude can be seen as a bridge that connects individuals
            to something greater than themselves, whether it is a higher power,
            the natural world, or the collective human experience.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            In essence, the philosophy of gratitude transcends cultural,
            religious, and spiritual boundaries, weaving through human history
            as a fundamental principle for living a meaningful and fulfilling
            life.
          </p>
        </div>
      </div>
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson17"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson16;
